var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "slider", staticClass: "slider-container" }, [
    _vm.$root.isMobile
      ? _c(
          "div",
          { staticClass: "slider" },
          _vm._l(_vm.data, function (item, key) {
            return _c("div", { key: key, staticClass: "item" }, [
              _c("img", {
                staticClass: "mb-16",
                class: `image-${key}`,
                attrs: { src: _vm.deepProperty(key, _vm.urlProperty) },
              }),
              _vm._v(" "),
              item[_vm.titleProperty]
                ? _c("h4", { staticClass: "mb-16" }, [
                    _vm._v(_vm._s(item[_vm.titleProperty])),
                  ])
                : _vm._e(),
              _vm._v(" "),
              item[_vm.descriptionProperty]
                ? _c("p", {
                    staticClass: "mb-0 small wordwrap",
                    domProps: {
                      innerHTML: _vm._s(item[_vm.descriptionProperty]),
                    },
                  })
                : _vm._e(),
            ])
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }